import React, { useEffect, useState } from 'react';
import ToastContainer from '@veneer/core/dist/scripts/toast_container';
import ToastNotification from '@veneer/core/dist/scripts/toast_notification';

let _tinstance = null;

class ToastsService {
  constructor() {
    // Singleton Object
    if (!_tinstance) {
      _tinstance = this;
    }
    this.toasts = [];
    this.toastListener = null;
    this.type = {
      POSITIVE: 'positive',
      NEGATIVE: 'negative',
      INFORMATIVE: 'informative',
    };
    return _tinstance;
  }
  updateToasts = () => {
    if (typeof this.toastListener == 'function') {
      this.toastListener(this.toasts);
    }
  };
  add = (text, type) => {
    type = type ? type : this.type.INFORMATIVE;
    this.toasts.push({ id: new Date().getTime(), text: text, type: type });
    this.updateToasts();
  };
  remove = (id) => {
    let idx = this.toasts.findIndex((t) => {
      return t.id === id;
    });
    if (idx !== -1) {
      this.toasts.splice(idx, 1);
    }
    this.updateToasts();
  };
}

const Toasts = () => {
  const [toasts, setToasts] = useState([]);
  const toastsService = new ToastsService();
  useEffect(() => {
    toastsService.toastListener = updateToasts;
    toastsService.updateToasts();
  }, []);

  const updateToasts = (toasts) => {
    let notifications = [];
    toasts.forEach((t) => {
      notifications.push(
        <ToastNotification
          i18n={{ close: L10n.t('global.text.close') }}
          id={t.id}
          key={'tn_' + t.id}
          onClose={toastsService.remove}
          text={t.text}
          type={t.type}
          timeout={t.timeout || 5}
        />,
      );
    });
    setToasts(notifications);
  };
  return <ToastContainer>{toasts}</ToastContainer>;
};

export { Toasts, ToastsService };
